module.exports = __webpack_public_path__ + "img/23.b15ac32f.jpg";